module.exports = "<div class=\"view\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/programming/src/app/quickstarts/view/view.component.html
// module id = 1617
// module chunks = 2